import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Dashboard from './pages/Dashboard';
import Orders from './pages/Orders';
import Users from './pages/Users';
import Shops from './pages/Shops';
import DeliveryBoys from './pages/DeliveryBoys';
import LiveTracking from './pages/LiveTracking';
import Reports from './pages/Reports';
import Notifications from './pages/Notifications';
import LoginPage from './pages/LoginPage';
import Settings from './pages/Settings';
import TestCheckout from './pages/TestCheckout';
import Expenses from './pages/Expenses';
import Coupons from './pages/Coupons';
import Banners from './pages/Banners';
import Payouts from './pages/Payouts';
import Disputes from './pages/Disputes';
import { db } from './firebase';
import { collection, query, where, onSnapshot } from 'firebase/firestore';

// Mock auth state – replace with Firebase Auth
function useAdminAuth() {
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    return localStorage.getItem('sangola_admin_auth') === 'true';
  });

  const login = (pass) => {
    if (pass === 'admin@sangola123') {
      localStorage.setItem('sangola_admin_auth', 'true');
      setIsLoggedIn(true);
      return true;
    }
    return false;
  };

  const logout = () => {
    localStorage.removeItem('sangola_admin_auth');
    setIsLoggedIn(false);
  };

  return { isLoggedIn, login, logout };
}

function AppLayout({ logout }) {
  const [activePage, setActivePage] = useState('dashboard');
  const [activeOrdersCount, setActiveOrdersCount] = useState(0);

  useEffect(() => {
    const q = query(
      collection(db, 'orders'),
      where('status', 'in', ['Pending', 'Ordered', 'Accepted', 'Ready', 'Picked', 'On the way'])
    );
    const unsubscribe = onSnapshot(q, (snapshot) => {
      setActiveOrdersCount(snapshot.size);
    }, (error) => {
      console.error("Error listening to active orders in AppLayout:", error);
    });
    return () => unsubscribe();
  }, []);

  const pageMap = {
    dashboard:   <Dashboard />,
    orders:      <Orders />,
    users:       <Users />,
    shops:       <Shops />,
    delivery:    <DeliveryBoys />,
    tracking:    <LiveTracking />,
    expenses:    <Expenses />,
    coupons:     <Coupons />,
    banners:     <Banners />,
    payouts:     <Payouts />,
    disputes:    <Disputes />,
    reports:     <Reports />,
    notifications: <Notifications />,
    settings:    <Settings />,
    testCheckout:<TestCheckout />,
  };

  return (
    <div className="app-layout">
      <Sidebar activePage={activePage} setActivePage={setActivePage} logout={logout} activeOrdersCount={activeOrdersCount} />
      <div className="main-content">
        <Header activePage={activePage} logout={logout} activeOrdersCount={activeOrdersCount} />
        <div className="page-content">
          {pageMap[activePage] || <Dashboard />}
        </div>
      </div>
    </div>
  );
}

export default function App() {
  const { isLoggedIn, login, logout } = useAdminAuth();

  if (!isLoggedIn) {
    return <LoginPage onLogin={login} />;
  }

  return <AppLayout logout={logout} />;
}
